// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as sidePanelActionCreators from 'esm-web-pro/redux/side-panel/actions';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';
import { isEmpty } from 'lodash';
import connectAPI from 'speed-js-react/src/api/connectAPI';
import { ApiClient } from 'speed-js-core';
import type { UUID } from 'esm-web-pro/types/common';


type Props = {
    continuousPipe: Object,
    onClose: Function,
    onSave: Function,
    mapIdentity: string,
    getInfrastructureProvider: Function,
};

const ContinuousPipeEditor = (props: Props) => {
    const {
        continuousPipe, mapIdentity, onClose, onSave, getInfrastructureProvider,
    } = props;
    const { infrastructure_provider: infrastructureProvider } = continuousPipe;
    const { is_property_owner: isPropertyOwner } = infrastructureProvider;

    const formRef = React.useRef(null);
    const [excludeFields, setExcludeFields] = React.useState([]);
    const [initial, setInitial] = React.useState({
        ...continuousPipe,
        infrastructure_provider: continuousPipe.infrastructure_provider.uuid,
        property_owner: continuousPipe.property_owner?.uuid,
    });
    const [provider, setProvider] = React.useState(continuousPipe.infrastructure_provider);

    React.useEffect(() => {
        const newExcludeFields = [];

        if (!continuousPipe.infrastructure_provider?.is_property_owner) {
            newExcludeFields.push('property_owner');
        }

        if (!isEmpty(newExcludeFields)) {
            setExcludeFields((e) => [...e, ...newExcludeFields]);
        }
    }, [isPropertyOwner]);

    React.useEffect(() => {
        const newExcludeFields = [];
        const newInitial = {};

        if (!provider?.is_property_owner) {
            newExcludeFields.push('property_owner');
            newInitial.property_owner = null;
        } else {
            newInitial.property_owner = continuousPipe.property_owner?.uuid;
        }

        setExcludeFields(newExcludeFields);
        setInitial({ ...initial, ...newInitial });

        if (!isEmpty(newInitial) && formRef.current) {
            Object.entries(newInitial).forEach(([field, value]) => {
                formRef.current.getFormikBag().setFieldValue(field, value);
            });
        }
    }, [provider]);

    const handleValuesChange = (values) => {
        const { infrastructure_provider: infrastructureProviderUuid } = values;

        if (infrastructureProviderUuid && infrastructureProviderUuid !== provider.uuid) {
            getInfrastructureProvider(infrastructureProviderUuid).then((res) => {
                setProvider(res);
            });
        }
    };

    return (
        <>
            <ApiForm
                forwardRef={formRef}
                resourceName="continuousPipe"
                optionsResourceArguments={[{ map_identity: mapIdentity }]}
                objectId={continuousPipe.uuid}
                initial={initial}
                excludeFields={excludeFields}
                onSave={onSave}
                onClose={onClose}
                height="100%"
                partialUpdate
                onValuesChanged={handleValuesChange}
                enableReinitialize
            />
        </>
    );
};

const apiCallback = (apiClient: ApiClient) => ({
    getInfrastructureProvider: {
        send: (uuid: UUID) => apiClient.resources.infrastructureProvider.get(uuid),
    },
});

export default connectAPI(apiCallback)(
    connect(null, (dispatch) => (bindActionCreators(sidePanelActionCreators, dispatch)))(
        withRouter(ContinuousPipeEditor),
    ),
);
